import { render, staticRenderFns } from "./NewApply.vue?vue&type=template&id=6ba05afc&scoped=true&lang=html&"
import script from "./NewApply.vue?vue&type=script&lang=js&"
export * from "./NewApply.vue?vue&type=script&lang=js&"
import style0 from "./NewApply.vue?vue&type=style&index=0&id=6ba05afc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba05afc",
  null
  
)

export default component.exports